export default __webpack_public_path__ + "static/media/ic-close.b851dd21.svg";